import AxiosAPI from "./AxiosAPI";

export const fetchViewPageApi= async (id) => {
    try {
        const response = await AxiosAPI.get(`/transaction/inventory/${id}`);
        // console.log(response);        
        return response.data;
    } catch (err) {
        return err?.response?.data || err.message || err;
    }
};



export const cancelInventory = async (data,key) => {
    try {
      const response = await AxiosAPI.post(`/transaction/inventory/${key}/cancel`, data);
      console.log(response);
      
      return response.data;
    } catch (error) {
      throw error;
    }
  };

export const fetchSalesDataApi = async (salesId) => {
  try {
    const response = await AxiosAPI.get(`/transaction/sales/${salesId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
